import React, { useState } from 'react'
import { Trans, useTranslation } from "react-i18next";
import uploadicon from "../../../assets/images/uploadicon.svg"
import 'bootstrap/dist/css/bootstrap.css';
import leftarrow from "../../../assets/images/left-arrow.svg";
import fileuploadpopup from "../../../assets/images/fileuploadpopup.svg";
import datecalender from "../../../assets/images/datecalender.svg"
import DatePicker3 from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Select, { components } from 'react-select';
import { useHistory } from "react-router-dom";
import { formatInputValue } from '../../../shared/helper';
import InputMask from 'react-input-mask';
import { NEW_URL } from '../../../constants/applicationConstants';
import { Footer } from '../../common/footer/footer';
import styles from './instituteRegistration.module.css';
const InstitutionalRegistrationJSX = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    field,
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    onDateChange,
    handleChange,
    onNextButtonClick,
    getSocialImage,
    onFileChange,
    imageName,
    profileImagePreviewUrl,
    imgURL,
    editMode
  } = props;


  const institutedetailsFieldNames = [
    'institutionName',
    'legalInstitutionName',
    'institutionEmail',
    'confirmInstitutionEmail',
    'segment',
    'category',
    'sizeOfInstitution',
    'dateOfIncorporation'
  ];
  const primaryContactNames = [
    'firstName',
    'lastName',
    'email',
    'phone'
  ];
  // const socialFieldNames = [
  //   'facebook',
  //   'insta',
  //   'twitter',
  //   'linkedin'
  // ];
  const addressFieldNames = [
    'postalCode',
    'province',
    'city',
    'country',
    'street'
 ];
  const billingFieldNames = [
     'billing_postalCode',
     'billing_province',
     'billing_city',
     'billing_country',
     'billing_street'
  ];
  const othersFieldNames = [
    'licenseNo',
    'regulatory',
    'institutionalContact',
    'customerContact',
    'website',
    'contactEmail'
 ];
 
 const instituteDetailsField =[]
 const primaryContactField = [];
 const addressDetailsField = []; 
 
 const billingDetailsField = [];

 const othersDetailsField = [];

 const socialDetailsField = [];
 

 field?.forEach((item) => {
  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.SOCIALMEDIA") {
    socialDetailsField.push(item);
    return;
  }

  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.PRIMARYCONTACT") {
    primaryContactField.push(item);
    return;
  }

  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.REGISTEREDADDRESS") {
    addressDetailsField.push(item);
    return;
  }

  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.BILLINGADDRESS") {
    billingDetailsField.push(item);
    return;
  }
  if (item.fieldType === "text" && item.contentHeading === "REGISTRATION.OTHERDETAILS") {
    othersDetailsField.push(item);
    return;
  }

  // if (item.fieldType === "multiSelect") {
    
  //   instituteDetailsField.push(item);    
    
  // }

  // Handle multiple fields
  if (item.fieldType === "multiple") {
    const isInstituteDetails = item.fields.some(f => institutedetailsFieldNames.includes(f.name));
    const isPrimaryContact = item.fields.some(f => primaryContactNames.includes(f.name));
    const isAddress = item.fields.some(f => addressFieldNames.includes(f.name));
    const isBilling = item.fields.some(f => billingFieldNames.includes(f.name));
    const isOther = item.fields.some(f => othersFieldNames.includes(f.name));

    if (isInstituteDetails) {
      instituteDetailsField.push(item);
    } else if (isPrimaryContact) {
      primaryContactField.push(item);    
    } else if (isAddress) {
      addressDetailsField.push(item);        
    } else if (isBilling) {      
      billingDetailsField.push(item);        
    } else if (isOther) {
      othersDetailsField.push(item);    
    } 
  }
  // Handle social fields
  else if (item.fieldType === "social") {    
    
      socialDetailsField.push(item);    
    
  }
  // Single input/select fields
  else if (institutedetailsFieldNames.includes(item.name)) {
    instituteDetailsField.push(item);
  } else if (primaryContactNames.includes(item.name)) {
    primaryContactField.push(item);  
  } else if (addressFieldNames.includes(item.name)) {
    addressDetailsField.push(item);  
  } else if (billingFieldNames.includes(item.name)) {
    billingDetailsField.push(item);
  } else if (othersFieldNames.includes(item.name)) {
    othersDetailsField.push(item);
  } 
});


const renderField = (item,i) => (
  <React.Fragment key={i}>
    
    {item.fieldType === "input" && (
  <div className="mb-4 input-container form-group">
    <label>{t(`${item.placeholder}`)} </label>

    {item.name === 'postalCode' || item.name === "billing_postalCode" ? (
      <InputMask
        mask={getMuskPattern(item.name)}
        value={formData[item.name]}
        name={item.name}
        onChange={onInputChangeHandler}
        onBlur={onTouchHandler}
      >
        {(inputProps) => (
          <input {...inputProps} className="input form-control" placeholder=" " disableUnderline />
        )}
      </InputMask>
    ) : item.name === 'phone' || item.name === 'institutionalContact' ||  item.name === 'customerContact' ? (
      <InputMask
        mask={getMuskPattern('phone')}
        value={formData[item.name]}
        name={item.name}
        onChange={onInputChangeHandler}
        onBlur={onTouchHandler}
      >
        {(inputProps) => (
          <input {...inputProps} type="tel" className="input form-control" placeholder=" " disableUnderline />
        )}
      </InputMask>
    ) : (
      <input
        onChange={onInputChangeHandler}
        onBlur={onTouchHandler}
        required
        type={item.type}
        className={
          item.isRequired && formError[item.name]
            ? "input form-control is-invalid"
            : "input form-control"
        }
        id={item.name}
        name={item.name}
        placeholder={" "}
        maxLength={item.maxLength}
        value={formData[item.name]}
      />
    )}

    {item.showIcon && (
      <img src={item.icon} alt={`${item.name}-icon`} className={`${styles.imageiconform}`} />
    )}

    <span className="text-danger">
      {item.isRequired &&
        formError[item.name] &&
        (formError[item.name] === "req"
          ? t(item.error)
          : t(item.type_error))}
    </span>
  </div>
)}

  {item.fieldType === "select" &&
    <div className={`mb-4 input-container selectboxmain form-group ${formData[item.name] && `selecttransition`}`}>
      <><label>{t(`${item.placeholder}`)}</label>
        <Select className={`selectbox`}
         classNamePrefix="custom-select"
          closeMenuOnSelect={true}
          options={item?.options}
          placeholder={" "}
          onChange={(e) => handleChange(e, item)}

          components={{
            Input: (props) => {
              // const { value: inputval } = props

              return <>
             
                <components.Input {...props} className={"input-container form-group"} >
                  {props.children}
                </components.Input>
              </>
            },
          }}

          value={item?.options.filter(ite => ite.value === formData[item.name])}
        />

      </>
    </div>
  }
  {
    item.fieldType === "multiple" &&


    <div className={`disgrid grid-${item.fields.length}`}>
      {/* {JSON.stringify(item.fields)} */}
      {item.fields.map((item, key) => renderField(item, key))}
      
    </div>
    
  }
  {
    item.fieldType === "text" &&
    <div className="primarycontact ">
      <h4 className="h4_style">{t(`${item.contentHeading}`)}</h4>
      <h5 className="h5_style">{t(`${item.SUBHEADING1}`)}</h5>
      <h5 className="h5_style pb-3">{t(`${item.SUBHEADING2}`)}</h5>
    
    </div>
  }
  {item.fieldType === "date" &&
    <>
      
      <DatePicker3 className="form-control" name="startDate"
        onChange={(date) => { onDateChange(date) }}
        inputPlaceholder="dd/mm/yyyy"
        shouldHighlightWeekends
        maximumDate={{
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }}
        wrapperClassName="input-container form-group"
        renderInput={({ ref }) => (
          <>
          <label>{t(`${item.placeholder}`)}</label>
            <input
              ref={ref}
              placeholder=" "
              type="text"
              required
              className="input form-control"
              value={formatInputValue(formData.dateOfIncorporation)}
            />
            
            
            <span className="dateim"><img src={datecalender} alt={' '} /></span>
          </>
        )}
        formatInputText={() => formatInputValue(formData.dateOfIncorporation)}
      />
    </>
  }
  {item.fieldType === "social" &&
    <div className="disgrid  grid-2">
      {
        item.types.map(items =>
          <div className="input-container form-group social-control">
  
            <input
              type="text"
              required=""
              name={items.name}
              className={
                items.isRequired && formError[items.name]
                  ? "input form-control  is-invalid"
                  : "input form-control"
              }
              placeholder={t("REGISTRATION.LINK")}
              onChange={onInputChangeHandler}
              value={formData[items.name]}
            />
           
           
            <img src={getSocialImage(items)} className="formscicon" alt={' '} />
            {items.showIcon && (
                  <img
                    src={items.icon}
                    alt={`${items.name}-icon`}
                  className={`${styles.imageiconform} social-controlicon`}
                  />
                )}
            <span className="text-danger">
              {items.isRequired &&
                formError[items.name] &&
                (formError[items.name] === "req"
                  ? t(items.error)
                  : t(items.type_error))}
            </span>
          </div>
        )
      }
    </div>
  }
  {item.fieldType === "multiSelect" &&
    <div>
<label>{t(`${item.placeholder}`)} </label>
      <Select className="mb-4 form-container form-group multiselect"
        classNamePrefix="multicustomselect"
        closeMenuOnSelect={false}
        isMulti
        options={item?.options}
        onChange={(e) => handleChange(e, item)}
        value={formData['category']}
        components={{
          Input: (props) => {
            // const { value } = props

            return <>
             

              <components.Input {...props} className={"input-container form-group"} >
                {props.children}
              </components.Input>
            </>
          },
          Option: (props) => {
            const { isSelected } = props

            return (
              <div>
                <components.Option {...props}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => null}
                  />
                  {props.children}
                </components.Option>
              </div>
            );
          }
        }}

      />
    </div>
  }
</React.Fragment>
);



  const [openModal, setOpenModal] = useState(false);

  const getMuskPattern = (name) =>
    name === 'phone' ? '(999) 999 9999' : 'a9a 9a9'

  const modalStatus = (action) => {
    setOpenModal(action);
  }
  const removeId = () => {
    const adminToken = localStorage.getItem('adminOldToken');
    const adminOldId = localStorage.getItem('adminOldId');
   
    localStorage.removeItem("VerifyInstituteID")
    localStorage.setItem("token", JSON.stringify(adminToken));
    localStorage.setItem("masterID", adminOldId);

    localStorage.removeItem("adminOldToken");
    localStorage.removeItem("adminOldId")

    history.goBack()
  }
  const flowType = localStorage.getItem("flowType");
  let verifyInstituteID = localStorage.getItem('VerifyInstituteID');

  return (
    <section className={`mainloginscreen instituteregistrationnew ${flowType}-registration`}>
      <div className="container">
      <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails}`}>
              <div className="detailsleft plaindetailsleft  d-flex align-items-center justify-content-center">
                <div className="back_btn" onClick={() =>removeId()}>
                  <img src={leftarrow} alt={' '} />
                </div>
                <h1>{t("REGISTRATION.INSTITUTETITLE")}</h1>
              </div>
              <div className="numberingwizerd">
                  <ul className="d-flex align-items-center justify-content-center ">
                    <li className="active">1</li>
                    <li>2</li>
                    <li>3</li>
                  
                  </ul>
                </div>
            </div>
           
          </div>
        <div className={`${styles.formsection}`}>
        
          <div className={`${styles.institutelogintext}`}>
          <h2 className="h2_style text-center">{t("REGISTRATION.LETUSKNOW")}</h2>
              <h6 className="h6_style text-center">{t("REGISTRATION.ENTERINFO")}</h6>
              <p className="text-center smalltext">{t("REGISTRATION.MANDATORY")} </p>
          <div className={`${styles.maindiv} mt-4 d-flex align-items-center`}>
          <div className="detailsleft">
          <div className={`${styles.uploadlogo}`} onClick={() => modalStatus(true)}>
                  {
                    profileImagePreviewUrl ?
                      <img
                        src={profileImagePreviewUrl}
                        height="170px"
                        width="250px"
                        alt="edit profile"
                      /> :
                      editMode ?
                        <img
                          src={`${NEW_URL}/${imgURL}`}
                          height="170px"
                          width="250px"
                          alt="edit profile"
                        />
                        : t("REGISTRATION.LOGO")
                  }
                </div>
                {
                  openModal &&
                  <div className="logochangemodal">
                    <div>
                      <button title="Close" className="modal-close" onClick={() => modalStatus(false)}>{t("REGISTRATION.CLOSE")}</button>
                      <div className="modal-header"><h2 className="h2_style">{t("REGISTRATION.LOGOCHANGE")}</h2></div>
                      <div className="modal-body mb-4">
                        <div className="modal-body-inner">
                          <div className="button_outerlogo">
                            <div className="btn_uploadlogo"><input type="file" id="upload_filelogo" name="" onChange={onFileChange} />
                              <label for="upload_filelogo">

                                {
                                  profileImagePreviewUrl ?
                                    <img
                                      src={profileImagePreviewUrl}
                                      height="170px"
                                      width="250px"
                                      alt="edit profile"
                                    /> :
                                    editMode ?
                                      <img
                                        src={`${NEW_URL}/${imgURL}`}
                                        height="170px"
                                        width="250px"
                                        alt="edit profile"
                                      />
                                      : <img src={fileuploadpopup} alt={' '} />
                                }
                              </label>
                            </div>
                          </div>
                          {imageName && <h6 className='text-center'>{imageName}</h6>}
                          {!(editMode || profileImagePreviewUrl) && <><h5 className="text-center h5_style">{t("REGISTRATION.UPLOADLOGOIMAGE")}</h5>
                            <p className="text-center">{t("REGISTRATION.ADDICON")}</p></>}
                        </div>
                      </div>
                      {(profileImagePreviewUrl || editMode) && <div className="modal-footer">
                        <button className="ctatwobutton widthhalf" onClick={() => modalStatus(false)}>Save</button>
                        <div className="button_outer">
                          <div className="btn_upload">
                            <input type="file" id="upload_file" name="" onChange={onFileChange} />
                            <label for="upload_file">{"Change Icon"}</label>
                          </div>
                        </div>
                      </div>}
                    </div>

                  </div>}

                <main className={`${styles.main_full_tp}`}>

                  <div className="uploadproduct">
                    <div className={`${styles.uploadbuttonouter} button_outer`}>
                      <div className={`${styles.uploadbutton} btn_upload`}>
                        <input type="file" id="upload_file" name=""
                          accept="image/png, image/gif, image/jpeg"
                          onChange={onFileChange}
                        />
                        <label for="upload_file">{t("REGISTRATION.FILEUPLOADTEXT")}<img src={uploadicon} alt={`icon`}/></label>
                      </div>
                    </div>
                  </div>
                  {/* <div className="btn_upload">
                        <input type="file" id="upload_file" name="" onChange={onFileChange} />
                        <label for="upload_file">{t("REGISTRATION.FILEUPLOADTEXT")}</label>
                      </div> */}
                  <div className="error_msg"> {t("REGISTRATION.IMAGEMSG")}</div>
                  <div className="error_msg"> {t("REGISTRATION.IMAGEMSGONE")}</div>
                  <div className="error_msg"> {t("REGISTRATION.IMAGEMSGTWO")}</div>
                </main>
              </div>
              </div>
            <div className="">
          
           
            
             
            {/* instituteDetailsField details section */}

            <div className={`${styles.maindiv}`}>  
            <h4 className="h4_style">{t("REGISTRATION.INSTITUTIONALDETAILS")}</h4>
              <h5 className="h5_style pb-3"><Trans>{t("REGISTRATION.INSTITUTEDESCRIPTION")}</Trans></h5>            
             {instituteDetailsField.map((item, i) => renderField(item, i))}
            </div>
             
            {/* primaryContactField details section */}
            <div className={`${styles.maindiv}`}>              
             {primaryContactField.map((item, i) => renderField(item, i))}
            </div>

            {/* addressDetailsField details section */}
            <div className={`${styles.maindiv}`}>              
             {addressDetailsField.map((item, i) => renderField(item, i))}
            </div>

            {/* billingDetailsField details section */}
            <div className={`${styles.maindiv}`}>              
             {billingDetailsField.map((item, i) => renderField(item, i))}
            </div>

            {/* othersDetailsField details section */}
            <div className={`${styles.maindiv} other-detail`}>              
             {othersDetailsField.map((item, i) => renderField(item, i))}
            </div>
            
            {/* socialDetailsField details section */}
            <div className={`${styles.maindiv} socialdiv`}>              
             {socialDetailsField.map((item, i) => renderField(item, i))}
            </div>



            <div className="d-flex justify-content-center">
                 <button className={formSubmitButtonDisable ? 'mt-4 mainbutton' : 'mt-4 mainbutton'} disabled={formSubmitButtonDisable} onClick={() => onNextButtonClick()}>{verifyInstituteID ? 'Verify Now' : t("REGISTRATION.NEXT")}</button>
           </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </section>
  );
};

export default InstitutionalRegistrationJSX;
